import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';
import { RegistrantsState } from './types';
import { GetRegistrants } from '@/connection/audiences/registrants';
import { GetCourseForEvent } from '@/connection/courses';

export const reducers = (create: ReducerCreators<RegistrantsState>) => ({
  fetchRegistrants: create.asyncThunk(
    async ({
      eventUuid,
      offset,
      limit,
      uploadPasscodeList,
      search,
      getDeleted,
      coursesEnabled,
      sort,
      lists,
      status, //registration status filter
      start,
      end,
    }: {
      eventUuid: string;
      offset: number;
      limit: number;
      uploadPasscodeList: number;
      search?: string;
      getDeleted?: boolean;
      coursesEnabled?: boolean;
      sort?: string;
      lists?: string;
      status?: string;
      start?: number;
      end?: number;
    }) => {
      const registrantsPage = await GetRegistrants({
        eventUuid,
        offset,
        limit,
        uploadPasscodeList,
        search,
        getDeleted,
        coursesEnabled,
        sort,
        lists,
        status,
        start,
        end,
      });
      return registrantsPage;
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.registrants = action.payload.registrations || [];
          state.registrantsCount = action.payload.count || 0;
        }
        state.loadingRegistrants = false;
      },
      pending: (state) => {
        state.loadingRegistrants = true;
      },
      rejected: (state, action) => {
        state.loadingRegistrants = false;
        console.error(action.error);
      },
    }
  ),
  fetchProjectCourse: create.asyncThunk(
    //TODO IAN: ONCE courses are done, this will move
    async ({ channel, projectUuid }: { channel: number; projectUuid: string }) => {
      const course = await GetCourseForEvent(channel, projectUuid);
      return course;
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.course = action.payload || [];
        }
        state.loadingCourse = false;
      },
      pending: (state) => {
        state.loadingCourse = true;
      },
      rejected: (state, action) => {
        state.loadingCourse = false;
        console.error(action.error);
      },
    }
  ),
  setPersonCourseCompletionState: create.reducer(
    (
      state,
      action: PayloadAction<{
        bl_profile: number;
        state: 'pdf-generating' | 'pdf-ready' | 'completed-no-pdf';
        certificateLocation: string | null;
      }>
    ) => {
      if (!state.registrants) return;
      state.registrants = state.registrants.map((registrant) => {
        if (registrant.bl_profile === action.payload.bl_profile) {
          switch (action.payload.state) {
            case 'pdf-generating': {
              return {
                ...registrant,
                pdf_url: action.payload.certificateLocation,
                course_completed: true,
                generating_pdf: String(registrant.bl_profile),
              };
            }
            case 'pdf-ready': {
              return {
                ...registrant,
                course_completed: true,
                generating_pdf: false,
              };
            }
            case 'completed-no-pdf': {
              return {
                ...registrant,
                course_completed: true,
              };
            }
          }
        }

        return registrant;
      });
    }
  ),
  resetRegistrants: create.reducer((state) => {
    if (state.registrants.length) {
      state.registrants = [];
    }
  }),
});
